/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceLocationPermission } from './DeviceLocationPermission';
import {
    DeviceLocationPermissionFromJSON,
    DeviceLocationPermissionFromJSONTyped,
    DeviceLocationPermissionToJSON,
    DeviceLocationPermissionToJSONTyped,
} from './DeviceLocationPermission';

/**
 * 
 * @export
 * @interface DeviceInfoRequest
 */
export interface DeviceInfoRequest {
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoRequest
     */
    battery_percentage?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoRequest
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoRequest
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoRequest
     */
    os?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoRequest
     */
    os_version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoRequest
     */
    network_operator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoRequest
     */
    app_version?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceInfoRequest
     */
    all_notifications_enabled: boolean;
    /**
     * 
     * @type {DeviceLocationPermission}
     * @memberof DeviceInfoRequest
     */
    device_location_permission?: DeviceLocationPermission;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoRequest
     */
    timestamp: number;
}



/**
 * Check if a given object implements the DeviceInfoRequest interface.
 */
export function instanceOfDeviceInfoRequest(value: object): value is DeviceInfoRequest {
    if (!('all_notifications_enabled' in value) || value['all_notifications_enabled'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function DeviceInfoRequestFromJSON(json: any): DeviceInfoRequest {
    return DeviceInfoRequestFromJSONTyped(json, false);
}

export function DeviceInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'battery_percentage': json['battery_percentage'] == null ? undefined : json['battery_percentage'],
        'model': json['model'] == null ? undefined : json['model'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'os': json['os'] == null ? undefined : json['os'],
        'os_version': json['os_version'] == null ? undefined : json['os_version'],
        'network_operator': json['network_operator'] == null ? undefined : json['network_operator'],
        'app_version': json['app_version'] == null ? undefined : json['app_version'],
        'all_notifications_enabled': json['all_notifications_enabled'],
        'device_location_permission': json['device_location_permission'] == null ? undefined : DeviceLocationPermissionFromJSON(json['device_location_permission']),
        'timestamp': json['timestamp'],
    };
}

export function DeviceInfoRequestToJSON(json: any): DeviceInfoRequest {
    return DeviceInfoRequestToJSONTyped(json, false);
}

export function DeviceInfoRequestToJSONTyped(value?: DeviceInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'battery_percentage': value['battery_percentage'],
        'model': value['model'],
        'manufacturer': value['manufacturer'],
        'os': value['os'],
        'os_version': value['os_version'],
        'network_operator': value['network_operator'],
        'app_version': value['app_version'],
        'all_notifications_enabled': value['all_notifications_enabled'],
        'device_location_permission': DeviceLocationPermissionToJSON(value['device_location_permission']),
        'timestamp': value['timestamp'],
    };
}

